<template>
  <Dialog custom-class="resetMobile-dialog" :show.sync="visible" @close="closeResetMobileDialog">
    <p class="title" >重置绑定手机号</p>
    <div style="text-align:center;width:300px;margin:auto">
      <el-form v-show="resetMobileStep == 1" ref="resetMobileForm1" :model="resetMobileForm1" :rules="rules0">
        <el-form-item prop="mobile">
          <el-input
            v-model="resetMobileForm1.mobile"
            style="max-width:360px"
            :readonly="true"
            placeholder="请输入手机号码"
          />
        </el-form-item>
        <el-form-item prop="mobileAuthCode">
          <el-row type="flex" justify="space-between" :gutter="10">
            <el-col>
              <el-input
                v-model="resetMobileForm1.mobileAuthCode"
                maxlength="6"
                placeholder="请输入验证码"
              />
            </el-col>
            <el-col style="flex:1">
              <el-button
                type="primary"
                class="sms-btn"
                :disabled="timeBtn"
                @click="getOldMobileSMS"
              >{{ smsSecond > 0 ? smsSecond + 'S' : '获取验证码' }}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item style="margin-bottom:10px">
          <el-button
            type="primary"
            style="width:100%"
            :disabled="nextBtn"
            @click="resetMobileNext"
          >下一步</el-button>
        </el-form-item>
      </el-form>
        <el-form v-show="resetMobileStep == 2" ref="resetMobileForm2" :model="resetMobileForm2" :rules="rules0">
          <el-form-item prop="mobile">
            <el-input v-model="resetMobileForm2.mobile" style="max-width:360px" placeholder="请输入新的手机号码" />
          </el-form-item>
          <el-form-item prop="mobileAuthCode">
            <el-row type="flex" justify="space-between" :gutter="10">
              <el-col>
                <el-input v-model="resetMobileForm2.mobileAuthCode" maxlength="6" placeholder="请输入验证码" />
              </el-col>
              <el-col style="flex:1">
                <el-button type="primary" class="sms-btn" :disabled="resetNew" @click="getNewMobileSMS">
                  {{ newSmsSecond > 0 ? newSmsSecond + 'S' : '获取验证码' }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item style="margin-bottom:10px">
            <el-button type="primary" style="width:100%" :disabled="resetMobileButtonDisabled" @click="resetMobile">
              确定绑定
            </el-button>
          </el-form-item>
      </el-form>
    </div>
  </Dialog>
</template>
<script>
import { mapGetters } from "vuex";
import rules from "@/utils/rules";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resetMobileStep: 1,
      resetMobileForm1: {
        mobile: null,
        mobileAuthCode: null
      },
      nextBtn: true,
      timeBtn: false,
      smsTimer: null,
      rules0: rules,
      newSmsTimer: null,
      resetMobileForm2: {},
      smsSecond: 0,
      newSmsSecond: 0,
      resetNew: false,
      forgetPasswordForm1: {},
      resetMobileButtonDisabled: true,
      
    };
  },
  computed: {
    // ...mapGetters(['user']),
    user(){
      this.resetMobileForm1.mobile = this.$store.state.user.mobile
      return this.$store.state.user;
    },
    visible: {
      get: function() {
        return this.dialogVisible;
      },
      set: function() {
        return this.dialogVisible;
      }
    }
  },
  watch: {
    visible: function(bool) {
      if (bool) {
        this.forgetPasswordForm1.mobile = this.user.mobile;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.smsTimer)
  },
  methods: {
    getOldMobileSMS() {
      this.smsSecond = 60
      // this.smsSecond = 5
      
      this.smsTimer = setInterval(() => {
        this.smsSecond = this.smsSecond - 1;
        this.nextBtn = false;
        if (this.smsSecond <= 0) {
          this.timeBtn = false;
          clearInterval(this.smsTimer)
        }
      }, 1000)
     
    },
    // 下一步
    resetMobileNext() {
      this.resetMobileStep = 2
    },
    // 确认绑定账号的验证码
    getNewMobileSMS() {
      this.$refs.resetMobileForm2.validateField('mobile', errorMsg => {
        if (errorMsg === '') {
           this.$http.send_sms_new_mobile(this.resetMobileForm2).then(res => {
            this.resetMobileButtonDisabled = false
            this.newSmsSecond = 60
            this.resetNew = true
            this.newSmsTimer = setInterval(() => {
              this.newSmsSecond = this.newSmsSecond - 1
              if (this.newSmsSecond <= 0) {
                this.resetNew = false
                clearInterval(this.newSmsTimer)
              }
            }, 1000)
            this.$toast('短信已发送!')
          })
        }
      })
    },
    // 确认认绑定
   
    getOldMobileSMS() {
      this.$refs.resetMobileForm1.validateField('mobile', errorMsg => {
        if (errorMsg === '') {
           this.$http.send_sms_old_mobile(this.resetMobileForm1).then(res => {
            this.nextBtn = false
            this.smsSecond = 60
            this.resetMobileOldMobileSmsButtonDisable = true
            this.smsTimer = setInterval(() => {
              this.smsSecond = this.smsSecond - 1
              if (this.smsSecond <= 0) {
                this.resetMobileOldMobileSmsButtonDisable = false
                clearInterval(this.smsTimer)
              }
            }, 1000)
            this.$toast('短信已发送!')
          })
        }
      })
    },
    resetMobileNext() {
      this.$refs.resetMobileForm1.validate(valid => {
        if (valid) {
           this.$http.auth_old_mobile(this.resetMobileForm1).then(res => {
            if(res.code ==0){
              this.resetMobileForm2.acccessAuthCode = res.data.acccessAuthCode
              this.resetMobileStep = 2
            }else{
              this.$toast(res.msg)
            }
            
          })
        } else {
          return false
        }
      })
    },
    resetMobile() {
      this.$refs.resetMobileForm2.validate(valid => {
        if (valid) {
           this.$http.change_mobile(this.resetMobileForm2).then(res => {
            this.resetMobileDialogVisible = false
          
            if(res.code === 0){
              this.$toast('修改成功!')
              this.$store.dispatch('getMyInfo')
              this.closeResetMobileDialog()
            }else{
              this.$toast(res.msg)
            }
            
          })
        } else {
          return false
        }
      })
    },
    
    closeResetMobileDialog() {
      if (this.resetMobileStep === 1) {
        this.$refs.resetMobileForm1.resetFields()
      } else {
        this.resetMobileStep = 1
        this.$refs.resetMobileForm1.resetFields()
        this.$refs.resetMobileForm2.resetFields()
      }
      this.$emit('update:dialogVisible', false)
    },
    closeDialog() {
      if (this.forgetPasswordStep === 1) {
        this.$refs.forgetPasswordForm1.resetFields()
      } else {
        this.forgetPasswordStep = 1
        this.$refs.forgetPasswordForm1.resetFields()
        this.$refs.forgetPasswordForm2.resetFields()
      }
      this.$emit('update:dialogVisible', false)
    },
    getForgetPasswordSMS() {
      this.$refs.forgetPasswordForm1.validateField('mobile', errorMsg => {
        if (errorMsg === '') {
           this.$http.rest_password_send_sms(this.forgetPasswordForm1).then(res => {
            this.forgetPasswordNextButtonDisabled = false
            this.smsSecond = 60
            this.forgetPasswordSmsButtonDisable = true
            this.smsTimer = setInterval(() => {
              this.smsSecond = this.smsSecond - 1
              if (this.smsSecond <= 0) {
                this.forgetPasswordSmsButtonDisable = false
                clearInterval(this.smsTimer)
              }
            }, 1000)
            this.$toast('短信已发送!')
          })
        }
      })
    },
    forgetPasswordNext() {
      this.$refs.forgetPasswordForm1.validate(valid => {
        if (valid) {
           this.$http.reset_password_confirm_sms(this.forgetPasswordForm1).then(res => {
            this.forgetPasswordForm2.acccessAuthCode = res.data.acccessAuthCode
            this.forgetPasswordStep = 2
          })
        } else {
          return false
        }
      })
    },
    resetPassword() {
      if (this.forgetPasswordForm2.password !== this.forgetPasswordForm2.password2) {
        this.$toast('两次密码输入不一致,请重新输入。')
        return
      }
      this.$refs.forgetPasswordForm2.validate(valid => {
        this.forgetPasswordForm2.mobile = this.forgetPasswordForm1.mobile
        if (valid) {
           this.$http.reset_password(this.forgetPasswordForm2).then(res => {
            this.$toast('密码修改成功。')
            this.forgetPasswordStep = 1
            this.$emit('update:dialogVisible', false)
            this.smsSecond = 0
          })
        }
      })
    },
  }
};
</script>
